import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconEmojiStyle0 = gravityIconIndividualCss;

const GravityIconEmoji = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '8c723250340d3456c1f2057b90f9d98e23179c54', color: this.color, size: this.size }, h("svg", { key: '9aa7217c147c1b98c7661712ad5709d638e1dac8', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '85f8ceab7979aa950017e5bc122e33d6ff5f80a5', d: "M11 16.5A5.751 5.751 0 0 1 5.707 13h10.586A5.752 5.752 0 0 1 11 16.5Zm3-9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM6.5 9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z", fill: "currentColor" }), h("path", { key: '9d16bbf50d7ac9cd27963fc0ffb0575b34b208de', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M20 11a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-1.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z", fill: "currentColor" }))));
    }
};
GravityIconEmoji.style = GravityIconEmojiStyle0;

export { GravityIconEmoji as gravity_icon_emoji };

//# sourceMappingURL=gravity-icon-emoji.entry.js.map